// Определяем правильно ли введено имя пользователя по объекту ответа
export function isUserNameIncorrect(response) {
  try {
    // Если status code равен 0 и в объекте ответа нет поля result то возвращаем true
    if (Number(response.data.status) === 0 && !response.data.result) {
      return true;
    }
    // Если произошла ошибка при обращении к свойствам возвращаем true
  } catch {
    return true;
  }
  return false;
}

// Определяем правильно ли введен код восстановления по объекту ответа
export function isRecoveryCodeIncorrect(response) {
  try {
    let recoveryToken = response.data.result.token;
    if (!recoveryToken) {
      return true;
    }
  } catch {
    return true;
  }
  return false;
}
